// extracted by mini-css-extract-plugin
module.exports = {"header":"sectionHeader_header__BzoKU","title":"sectionHeader_title__1GVbH","edit":"sectionHeader_edit__UiKUJ"};